<template>
    <Modal @modal:dismiss="$emit('dismiss')">
        <h3 slot="header">{{ value.id ? 'Modifier' : 'Ajouter' }} un flux WMS</h3>

        <div slot="body">
            <div class="form-control">
                <label>
                    Nom du flux <b>(obligatoire)</b>
                    <CustomInputUniqChecker
                        required
                        class="stretch"
                        v-model="value.name"
                        :err-msg="`Un flux nommé ${value.name} existe déjà`"
                        url="/api/check/wms/name"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    URL du flux <b>(obligatoire)</b>
                    <CustomInput type="url" required class="stretch" v-model="value.url" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Couches (layers) du flux <b>(obligatoire)</b>
                    <CustomInput required class="stretch" v-model="value.layer" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Format des images <b>(obligatoire)</b>
                    <CustomInput required class="stretch" v-model="value.format" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Transparence&nbsp;
                    <CustomCheckbox class="stretch" v-model="value.alpha"></CustomCheckbox>
                </label>
            </div>
            <div class="form-control">
                <label>
                    Niveau de zoom maximal
                    <CustomInput type="integer" class="stretch" v-model="value.maxzoom" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Droits d'auteur
                    <CustomInput class="stretch" v-model="value.attribution" />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Affichage (couche de base ou superposée) <b>(obligatoire)</b><br />
                    <select v-model="value.type">
                        <option
                            v-for="stream_type_option in stream_type_options"
                            v-bind:key="stream_type_option.value"
                            v-bind:value="stream_type_option.value"
                        >
                            {{ stream_type_option.text }}
                        </option>
                    </select>
                </label>
            </div>
        </div>
        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch" @click="$emit('dismiss')">Annuler</CustomButton>
                <CustomButton class="stretch default" @click="$emit('close')">
                    Enregistrer
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import CustomInput from './../Input';
import CustomButton from './../Button';
import CustomInputUniqChecker from './../InputUniqChecker';
import CustomCheckbox from './../Checkbox';

export default {
    data() {
        return {
            stream_type_options: [
                { value: 'base', text: 'Couche de base' },
                { value: 'overlay', text: 'Couche superposée' },
            ],
        };
    },
    props: ['value'],
    components: {
        Modal,
        CustomInput,
        CustomButton,
        CustomInputUniqChecker,
        CustomCheckbox,
    },
};
</script>

<style lang="scss"></style>
